<template>
    <div class="digit-wrapper">
        <template v-for="d in digits">
            <div
                v-if="group && d > 1 && (d - 1) % group === 0"
                :key="'s' + (d - 1)"
                class="separator">&mdash;</div>
            <input
                type="text"
                :key="d - 1"
                :value="values[d - 1]"
                @input="onInput(d - 1, $event)"
                @paste="onPaste(d - 1, $event)"
                @keydown="onKeydown(d - 1, $event)"
                ref="digits"
                :disabled="disabled"
            >
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                values: []
            };
        },
        props: {
            digits: {
                type: Number,
                required: true
            },
            group: {
                type: Number,
                default: 0
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            reset() {
                for (let i = this.digits - 1; i >= 0; i--) {
                    this.setValue(i, '');
                }
            },
            onInput(key, e) {
                let value = e.target.value.replace(/[^0-9]/g, '');
                let pos = e.target.selectionStart;
                value = value.substr(Math.min(pos, value.length) - 1, 1);
                this.setValue(key, value);
            },
            onPaste(key, e) {
                e.preventDefault();
                let inserted = e.clipboardData.getData('text/plain');
                if (!inserted) return;
                inserted = inserted.replace(/[^0-9]/g, '');
                if (!inserted) return;
                inserted = inserted.split('');
                for (let i = 0; i < inserted.length; i++) {
                    if (key + i >= this.digits) break;
                    this.setValue(key + i, inserted[i]);
                }
            },
            setValue(key, value) {
                this.values[key] = value;
                let input = this.$refs.digits[key];
                input.value = value;
                if (value && key + 1 < this.digits) {
                    let nextInput = this.$refs.digits[key + 1];
                    nextInput.focus();
                    nextInput.setSelectionRange(0, 0);
                } else {
                    input.focus();
                    input.setSelectionRange(value.length, value.length);
                }

                if (this.values.every(val => !!val)) {
                    this.$emit('entered', this.values.join(''));
                }
            },
            onKeydown(key, e) {
                let pos = e.target.selectionStart;
                if (pos !== e.target.selectionEnd) return;
                if (key > 0) {
                    if (e.which === 8 && pos === 0) { // backspace
                        this.setValue(key - 1, '');
                    } else if (e.which === 37) { // left arrow
                        let prevInput = this.$refs.digits[key - 1];
                        prevInput.focus();
                        prevInput.setSelectionRange(0, 0);
                    }
                }
                if (key + 1 < this.digits) {
                    if (e.which === 46 && pos === 1) { // delete
                        this.setValue(key + 1, '');
                    } else if (e.which === 39) { // right arrow
                        let nextInput = this.$refs.digits[key + 1];
                        nextInput.focus();
                        nextInput.setSelectionRange(nextInput.value.length, nextInput.value.length);
                    }
                }
            }
        },
        watch: {
            digits() {
                this.reset();
            }
        },
        created() {
            this.values = Array(this.digits).fill('');
        }
    }
</script>

<style lang="scss" scoped>
    .digit-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    input {
        font-size: 2em;
        font-weight: lighter;
        height: 1.4em;
        padding: 0 0 2px 0;
        text-align: center;
        width: 1.1em;
        border: 1px solid #999;
        border-radius: 3px;
        margin: 0 5px;
    }

    .separator {
        color: #999;
        margin: 0 2px;
    }
</style>